import { render, staticRenderFns } from "./suprimento.vue?vue&type=template&id=497cfb00"
import script from "./suprimento.vue?vue&type=script&lang=js"
export * from "./suprimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports